import { baseApi } from './baseApi';

export const internalTasksApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInternalTasks: builder.query({
      query: (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.entityType) params.append('entity_type', filters.entityType);
        if (filters.entityId) params.append('entity_id', filters.entityId);
        if (filters.status) params.append('status', filters.status);
        if (filters.priority) params.append('priority', filters.priority);
        if (filters.assignedTo) params.append('assigned_to', filters.assignedTo);
        if (filters.noteId) params.append('note_id', filters.noteId);
        const qs = params.toString();
        return `/internal-tasks${qs ? '?' + qs : ''}`;
      },
      providesTags: (result, error, filters) => {
        const tags = [{ type: 'InternalTask', id: 'LIST' }];
        if (filters?.entityType && filters?.entityId) {
          tags.push({ type: 'InternalTask', id: `${filters.entityType}-${filters.entityId}` });
        }
        return tags;
      },
    }),

    getInternalTask: builder.query({
      query: (id) => `/internal-tasks/${id}`,
      providesTags: (result, error, id) => [{ type: 'InternalTask', id }],
    }),

    createInternalTask: builder.mutation({
      query: (data) => ({
        url: '/internal-tasks',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'InternalTask', id: 'LIST' }],
    }),

    createTasksFromSuggestions: builder.mutation({
      query: ({ suggestions, noteId, entityType, entityId }) => ({
        url: '/internal-tasks/from-suggestions',
        method: 'POST',
        body: {
          suggestions,
          note_id: noteId,
          entity_type: entityType,
          entity_id: entityId,
        },
      }),
      invalidatesTags: (result, error, { entityType, entityId }) => [
        { type: 'InternalTask', id: 'LIST' },
        { type: 'InternalTask', id: `${entityType}-${entityId}` },
      ],
    }),

    updateInternalTask: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/internal-tasks/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'InternalTask', id },
        { type: 'InternalTask', id: 'LIST' },
      ],
    }),

    deleteInternalTask: builder.mutation({
      query: (id) => ({
        url: `/internal-tasks/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'InternalTask', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetInternalTasksQuery,
  useGetInternalTaskQuery,
  useCreateInternalTaskMutation,
  useCreateTasksFromSuggestionsMutation,
  useUpdateInternalTaskMutation,
  useDeleteInternalTaskMutation,
} = internalTasksApi;
